<template>
    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
    <transition name="slide"  v-if="isMobile" >      
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition> 

    <section class="d-flex wrapper" v-else>
        <div class="block block__notifications">
          <keep-alive>
            <transition  
              name="slide"
            >
              <router-view></router-view>
            </transition>
          </keep-alive>
        </div>
    </section>     
    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
</template>


<script>
import CatMixin from './CatMixin'
import { mapGetters } from 'vuex'
// import Sidebar from '../../module/sidebar/Sidebar'

export default {
  name:"notifications",
    components:{
        // Sidebar,
    },
    mixins: [
      CatMixin
    ],    
    data () {
      return {
      }
    },
    mounted(){
    },
  computed: {
    ...mapGetters([
    ])
  },
  methods : {           

  },
};
</script>
